import { Experiment } from '@cian/experiments/ab';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackServiceClick, trackServiceShow } from './tracking';
import { openCianGptPopup } from './utils/openCianGptPopup';
import { Carousel } from '../../components/Carousel';
import { Service } from '../../components/Service';
import { ServicesRow } from '../../components/ServicesRow';
import { AUD_MOBILE_REDESIGN_MAINPAGE } from '../../constants/experiments';
import { selectServices } from '../../selectors/services';

export const ServicesContainer: React.FC = () => {
  const services = useSelector(selectServices);

  if (!services.length) {
    return null;
  }

  const handleClick = (key: string) => {
    return (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (key === 'chat_bot') {
        event.preventDefault();
        openCianGptPopup();
      }

      trackServiceClick(key);
    };
  };

  const handleShow = (key: string) => {
    return () => trackServiceShow(key);
  };

  return (
    <>
      <Experiment name={AUD_MOBILE_REDESIGN_MAINPAGE} group="A" default>
        <Carousel>
          {services.map(({ key, title, url, image }) => (
            <Service
              key={`service-${key}`}
              title={title}
              url={url}
              image={image}
              onShow={handleShow(key)}
              onClick={handleClick(key)}
            />
          ))}
        </Carousel>
      </Experiment>

      <Experiment name={AUD_MOBILE_REDESIGN_MAINPAGE} group="B">
        <ServicesRow services={services} onClick={handleClick} />
      </Experiment>

      <Experiment name={AUD_MOBILE_REDESIGN_MAINPAGE} group="C">
        <Carousel>
          {services.map(({ key, title, url, image }) => (
            <Service
              key={`service-${key}`}
              title={title}
              url={url}
              image={image}
              onShow={handleShow(key)}
              onClick={handleClick(key)}
            />
          ))}
        </Carousel>
      </Experiment>
    </>
  );
};
